module.exports = __webpack_public_path__ + "static/logo-header-resized-12d51b8334b8241db955e84a3d7ce067.png";